import {
    ADMINS_REQUESTED,
    ADMINS_SUCCEEDED,
    ADMINS_FAILED,
    DELETE_ADMINS_REQUESTED,
    DELETE_ADMINS_SUCCEEDED,
    DELETE_ADMINS_FAILED,
    ADD_ADMINS_REQUESTED,
    ADD_ADMINS_SUCCEEDED,
    ADD_ADMINS_FAILED,
    CITIZEN_SCIENTIST_REQUESTED,
    CITIZEN_SCIENTIST_SUCCEEDED,
    CITIZEN_SCIENTIST_FAILED,
    ADD_CITIZEN_SCIENTIST_REQUESTED,
    ADD_CITIZEN_SCIENTIST_SUCCEEDED,
    ADD_CITIZEN_SCIENTIST_FAILED,
    DELETE_CITIZEN_SCIENTIST_REQUESTED,
    DELETE_CITIZEN_SCIENTIST_SUCCEEDED,
    DELETE_CITIZEN_SCIENTIST_FAILED,
    CHILD_INSPIRE_PARTNER_SUCCEEDED,
    CHILD_INSPIRE_PARTNER_FAILED,
    CHILD_INSIRE_CAMPUS_PARTNER_SUCCEEDED,
    CHILD_INSPIRE_CAMPUS_PARTNER_FAILED,
    CHILD_PARTNER_FAILED,
    ADD_CHILD_ADMIN_SUCCEEDED,
    ADD_CHILD_ADMIN_FAILED,
    ADD_CHILD_ADMIN_REQUESTED,
    CHILD_INSPIRE_CAMPUS_PARTNER_REQUESTED,
    CHILD_INSPIRE_PARTNER_REQUESTED,
    REMOVE_CHILD_ADMIN_REQUESTED,
    REMOVE_CHILD_ADMIN_SUCCEEDED,
    REMOVE_CHILD_ADMIN_FAILED,
    CREATE_PARTNER_REQUESTED,
    CREATE_PARTNER_SUCCEEDED,
    CREATE_PARTNER_FAILED,
    CLEAR_ERROR_STATE,
    DELETE_INVITE_REQUESTED,
    DELETE_INVITE_SUCCEEDED,
    DELETE_INVITE_FAILED,
    USERS_REQUESTED,
    USERS_SUCCEEDED,
    USERS_FAILED,
    ADD_USERS_FAILED,
    ADD_USERS_REQUESTED,
    ADD_USERS_SUCCEEDED,
    REMOVE_USER_FAILED,
    REMOVE_USER_REQUESTED,
    REMOVE_USER_SUCCEEDED,
    RESEND_INVITE,
} from './constants';

export function resendInvite(email) {
    return {
        type: RESEND_INVITE,
        email,
    };
}

export function removeUsersRequested(email) {
    return {
        type: REMOVE_USER_REQUESTED,
        email,
    };
}

export function removeUsersSucceeded() {
    return {
        type: REMOVE_USER_SUCCEEDED,
    };
}

export function removeUsersFailed(error) {
    return {
        type: REMOVE_USER_FAILED,
        error,
    };
}

export function usersRequested() {
    return {
        type: USERS_REQUESTED,
    };
}

export function usersSucceeded(users) {
    return {
        type: USERS_SUCCEEDED,
        users,
    };
}

export function usersFailed(error) {
    return {
        type: USERS_FAILED,
        error,
    };
}

export function addUserRequested(email, roles) {
    return {
        type: ADD_USERS_REQUESTED,
        email,
        roles,
    };
}

export function addUserSucceeded() {
    return {
        type: ADD_USERS_SUCCEEDED,
    };
}

export function addUserFailed(error) {
    return {
        type: ADD_USERS_FAILED,
        error,
    };
}

export function adminsRequested() {
    return {
        type: ADMINS_REQUESTED,
    };
}

export function adminsSucceeded(admins) {
    return {
        type: ADMINS_SUCCEEDED,
        admins,
    };
}

export function adminsFailed(error) {
    return {
        type: ADMINS_FAILED,
        error,
    };
}

export function deleteAdminsRequested(id) {
    return {
        type: DELETE_ADMINS_REQUESTED,
        id,
    };
}

export function deleteAdminsSucceeded() {
    return {
        type: DELETE_ADMINS_SUCCEEDED,
    };
}

export function deleteAdminsFailed(error) {
    return {
        type: DELETE_ADMINS_FAILED,
        error,
    };
}

export function addAdminsRequested(email) {
    return {
        type: ADD_ADMINS_REQUESTED,
        email,
    };
}

export function addAdminsSucceeded(message) {
    return {
        type: ADD_ADMINS_SUCCEEDED,
        message,
    };
}

export function addAdminsFailed(error) {
    return {
        type: ADD_ADMINS_FAILED,
        error,
    };
}

export function citizenScientistRequested() {
    return {
        type: CITIZEN_SCIENTIST_REQUESTED,
    };
}

export function citizenScientistSucceeded(scientist) {
    return {
        type: CITIZEN_SCIENTIST_SUCCEEDED,
        scientist,
    };
}

export function citizenScientistFailed(error) {
    return {
        type: CITIZEN_SCIENTIST_FAILED,
        error,
    };
}

export function AddCitizenScientistRequested(email) {
    return {
        type: ADD_CITIZEN_SCIENTIST_REQUESTED,
        email,
    };
}

export function addCitizenScientistSucceeded(message) {
    return {
        type: ADD_CITIZEN_SCIENTIST_SUCCEEDED,
        message,
    };
}

export function addCitizenScientistFailed(error) {
    return {
        type: ADD_CITIZEN_SCIENTIST_FAILED,
        error,
    };
}

export function deleteCitizenScientistRequested(id) {
    return {
        type: DELETE_CITIZEN_SCIENTIST_REQUESTED,
        id,
    };
}

export function deleteCitizenScientistSucceeded(message) {
    return {
        type: DELETE_CITIZEN_SCIENTIST_SUCCEEDED,
        message,
    };
}

export function deleteCitizenScientistFailed(error) {
    return {
        type: DELETE_CITIZEN_SCIENTIST_FAILED,
        error,
    };
}

export function childInspirePartnerRequested() {
    return {
        type: CHILD_INSPIRE_PARTNER_REQUESTED,
    };
}

export function childInspireCampusPartnerRequested() {
    return {
        type: CHILD_INSPIRE_CAMPUS_PARTNER_REQUESTED,
    };
}

export function childInspirePartnerSucceeded(inspire) {
    return {
        type: CHILD_INSPIRE_PARTNER_SUCCEEDED,
        inspire,
    };
}

export function childInspirePartnerFailed(error) {
    return {
        type: CHILD_INSPIRE_PARTNER_FAILED,
        error,
    };
}

export function childInspireCampusPartnerSucceeded(campus) {
    return {
        type: CHILD_INSIRE_CAMPUS_PARTNER_SUCCEEDED,
        campus,
    };
}

export function childInspireCampusPartnerFailed(error) {
    return {
        type: CHILD_INSPIRE_CAMPUS_PARTNER_FAILED,
        error,
    };
}

export function childPartnerFailed(error) {
    return {
        type: CHILD_PARTNER_FAILED,
        error,
    };
}

export function addChildAdminRequested(childId, email, childType) {
    return {
        type: ADD_CHILD_ADMIN_REQUESTED,
        childId,
        email,
        childType,
    };
}

export function addChildAdminSucceeded(message) {
    return {
        type: ADD_CHILD_ADMIN_SUCCEEDED,
        message,
    };
}

export function addChildAdminFailed(id, error) {
    return {
        type: ADD_CHILD_ADMIN_FAILED,
        id,
        error,
    };
}

export function removeChildAdminRequested(childId, userId, childType) {
    return {
        type: REMOVE_CHILD_ADMIN_REQUESTED,
        childId,
        userId,
        childType,
    };
}

export function removeChildAdminSucceeded(message) {
    return {
        type: REMOVE_CHILD_ADMIN_SUCCEEDED,
        message,
    };
}

export function removeChildAdminFailed(id, error) {
    return {
        type: REMOVE_CHILD_ADMIN_FAILED,
        id,
        error,
    };
}

export function deleteInviteRequested(email, partnerId, sectionType) {
    console.log('Reqiested Invite Delete');
    return {
        type: DELETE_INVITE_REQUESTED,
        email,
        partnerId,
        sectionType,
    };
}

export function deleteInviteSucceeded(message) {
    return {
        type: DELETE_INVITE_SUCCEEDED,
        message,
    };
}

export function deleteInviteFailed(error) {
    return {
        type: DELETE_INVITE_FAILED,
        error,
    };
}

export function createPartnerREquested(partnerDetails) {
    return {
        type: CREATE_PARTNER_REQUESTED,
        partnerDetails,
    };
}

export function createPartnerSucceeded(message) {
    return {
        type: CREATE_PARTNER_SUCCEEDED,
        message,
    };
}

export function createPartnerFailed(error) {
    return {
        type: CREATE_PARTNER_FAILED,
        error,
    };
}

export function clearErrorState() {
    return {
        type: CLEAR_ERROR_STATE,
    };
}
